import { useState, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  FormControl,
  Input,
  FilledInput,
  IconButton,
  InputLabel,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";
import { EventContext } from "../../../contexts/EventContext";

const SwapDialog = ({ open, close }) => {
  const { pairingEvent } = useContext(EventContext);
  const [searchVal, setSearchVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [newEmail, setNewEmail] = useState("");

  const handleSearch = async () => {
    if (searchVal.length < 3) return;
    setLoading(true);
    const body = {
      value: searchVal,
    };
    const result = await request("users/search", "post", body);
    if (result.success) {
      setUsers(result.users);
      // console.log(result.users);
    }
    setLoading(false);
  };

  const handleAdd = async () => {
    const body = {
      userId: selectedUser._id,
      eventId: pairingEvent.event._id,
    };

    const result = await request("events/addattendee", "post", body);
    if (result.success) {
      toast.success("User added successfully!");
    }
    handleClose();
  };

  const handleCreateAndAdd = async () => {
    const body = {
      userData: {
        firstName,
        lastName,
        email: newEmail,
      },
      eventId: pairingEvent.event._id,
    };
    const result = await request("events/createandadd", "post", body);
    if (result.success) {
      toast.success("User created and added to event");
      handleClose();
    }
  };

  const handleClose = () => {
    setUsers([]);
    setSearchVal("");
    setSelectedUser(null);
    setFirstName("");
    setLastName("");
    setNewEmail("");
    close();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add Attendee</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
      >
        <Typography variant="h6">Search Existing User</Typography>
        <Typography sx={{ marginBottom: "20px" }}>
          Search for the attendee you want to add by entering their email
        </Typography>

        {/* <TextField label="Email" value={searchVal} onChange={(e) => setSearchVal(e.target.value)} /> */}
        {selectedUser ? (
          <div
            style={{
              width: "100%",
              padding: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              sx={{ width: "80%" }}
              onClick={handleAdd}
            >
              Add!
            </Button>
          </div>
        ) : null}

        <FormControl variant="filled" sx={{ marginTop: "20px" }}>
          <InputLabel>Email</InputLabel>
          <FilledInput
            type="text"
            value={searchVal}
            onChange={(e) => setSearchVal(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={handleSearch}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
        </FormControl>
        {loading ? (
          <div
            style={{
              padding: "20px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <List
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              position: "relative",
              overflow: "auto",
              maxHeight: 300,
              "& ul": { padding: 0 },
            }}
          >
            {users.map((u, i) => {
              return (
                <ListItem key={`${i}-${u._id}`}>
                  <ListItemButton onClick={() => setSelectedUser({ ...u })}>
                    {u?.email}
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        )}

        <Typography variant="h6" sx={{ marginTop: "20px" }}>
          Or Create New User
        </Typography>
        <TextField
          label="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          fullWidth
          sx={{ marginTop: "10px" }}
        />
        <TextField
          label="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          fullWidth
          sx={{ marginTop: "10px" }}
        />
        <TextField
          label="Email"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          fullWidth
          sx={{ marginTop: "10px" }}
        />
        <Button
          variant="contained"
          sx={{ marginTop: "15px" }}
          fullWidth
          onClick={handleCreateAndAdd}
        >
          Create and Add User
        </Button>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={()=>setRemoveUserOpen(false)}>Cancel</Button>
                    <Button onClick={handleConfirm}>Confirm</Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default SwapDialog;
